// API client for Studio Grape backend. Uses session token from localStorage.
const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const TOKEN_KEY = "sg_session_token";

// Emergent's platform monitoring script wraps window.fetch and drains the
// response body of non-OK responses for error reporting, which causes
// "body stream already read" when our code tries to read the body. We capture
// the original fetch in index.html (before that script loads) and use it here
// so error responses still reach the user.
const rawFetch = (typeof window !== "undefined" && window.__origFetch) || fetch;

function authHeader() {
  const token = localStorage.getItem(TOKEN_KEY);
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function req(method, path, body) {
  const headers = { "Content-Type": "application/json", ...authHeader() };
  const res = await rawFetch(`${BASE}/api${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  let txt = "";
  try {
    txt = await res.text();
  } catch (_) {
    // Body already consumed by an upstream interceptor — fall through with empty text.
  }
  let data = null;
  if (txt) {
    try { data = JSON.parse(txt); } catch (_) { data = null; }
  }
  if (!res.ok) {
    const msg =
      (data && (data.detail || data.message)) ||
      (txt && txt.slice(0, 200)) ||
      `HTTP ${res.status}${res.statusText ? ` ${res.statusText}` : ""}`;
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  return data;
}

export const api = {
  get: (path) => req("GET", path),
  post: (path, body) => req("POST", path, body),
  patch: (path, body) => req("PATCH", path, body),
  delete: (path) => req("DELETE", path),
};

export const baseUrl = BASE;
